import { ComboField } from '@components/Fields/ComboField';
import { DocumentoField } from '@components/Fields/DocumentoField';
import { IntegerField } from '@components/Fields/IntegerField';
import { StringField } from '@components/Fields/StringField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { MenuItem } from '@material-ui/core';
import { IComboRemetenteWhatsapp } from '@model/RemetenteWhatsapp';
import { IClienteFilter } from '@services/ClienteService';
import React from 'react';

export type ClienteFilterProps = {
    filter: IFilter<IClienteFilter>
    isLoading: boolean
    remetenteWhatsappCombo: IComboRemetenteWhatsapp
}

export function ClienteFilter ({ filter, isLoading, remetenteWhatsappCombo }: ClienteFilterProps) {
    const nomeInputRef = React.createRef<HTMLInputElement>();

    const handleReset = React.useCallback(() => {
        filter.resetFilter();
        nomeInputRef.current?.focus();
    }, [filter, nomeInputRef]);

    React.useEffect(() => {
        nomeInputRef.current?.focus();
    }, [nomeInputRef])

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={1}>
                    <IntegerField
                        field={filter.fields.clienteId}
                        label="ID Cliente"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={3}>
                    <StringField
                        inputRef={nomeInputRef}
                        field={filter.fields.nome}
                        label="Nome"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <DocumentoField
                        maskType="both"
                        field={filter.fields.cpf}
                        onEnter={filter.handleFilterRequest}
                        dynamicLabels={{
                            cpf: "CPF",
                            cnpj: "CNPJ"
                        }}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.whatsappEnvio}
                        label="Remetente"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value="">Todos</MenuItem>
                        {
                            remetenteWhatsappCombo.createOptionsWithNumero()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.clienteStatus}
                        label="Status"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value="0">Todos</MenuItem>
                        <MenuItem key={1} value="1">Somente Ativos</MenuItem>
                        <MenuItem key={2} value="2">Somente Inativos</MenuItem>
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}